const containsRTLCharacters = (str: string) => {
  // Unicode ranges for Hebrew and Arabic characters
  const rtlPattern = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F]/;

  // Test if the string contains any RTL characters
  return rtlPattern.test(str);
};

export default containsRTLCharacters;
